import React from "react";

import "./optionChooser.css";
import CheckIcon from "../assets/icons/checkIcon";

interface OptionChooserProps {
    options: string[];
    active?: string;
    label?: string;
    className?: string;
    setActive: (v: string) => void;
}

export default function OptionChooser(props: OptionChooserProps) {
    return <div className={"option-chooser txoria-text-field" + (props.className ? " " + props.className : "")}>
        {props.label && <label>{props.label}</label>}
        <div className="options">
            {props.options.map(e => {
                return <div onClick={() => {
                    props.setActive(e);
                }} className={"option grey-box" + (props.active == e ? " active" : "")}>
                    <a>{props.active == e ? <CheckIcon/> : <></>}{e}</a>
                    </div>;
            })}
        </div>
    </div>
}